// extracted by mini-css-extract-plugin
module.exports = {"DesktopNavigation":"DesktopNavigation_DesktopNavigation__xpPI4","DesktopNavigation_list":"DesktopNavigation_DesktopNavigation_list__oYXDa"};